import { render, staticRenderFns } from "./AddAccessControlDialog.vue?vue&type=template&id=47e032c8&"
import script from "./AddAccessControlDialog.vue?vue&type=script&lang=ts&"
export * from "./AddAccessControlDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports